import gql from 'graphql-tag';





















const getFilteredVoiceOverArtistsQuery = gql`
  query GetFilteredVoiceOverArtists($filter: FilterOptions) {
    getFilteredVoiceOverArtists(filterOptions: $filter) {
      count
      VoiceOverArtist {
        voiceOverArtistId
        organisationId
        artistName
        artistLink
        description
        gender
        ageRange
        languages
        voiceOver
        customThumbnail
        status
        targetWorkspace
        createdByUserId
        createdAt
        updatedAt
        deletedAt
      }
    }
  }
`;

export default (() => ({
  query: getFilteredVoiceOverArtistsQuery,
  module: 'system-asset-library',
  ignoreCache: true,
  buildVariables: (filter) => ({
    filter
  })
}));